import { Provider } from "react-redux";
import "./App.css";
import store from "./store";

import { Suspense } from "react";

import Main from "../src/pages/Main";
import { LoadingScreen } from "../src/components/loading-screen";

import { SnackbarProvider } from "./components/snackbar";
import SnackbarCloseButton from "../src/components/shared/SnackbarCloseButton";

function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Main />
    </Suspense>
  );
}

export default () => {
  return (
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={5}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        action={(snackbarKey) => (
          <SnackbarCloseButton snackbarKey={snackbarKey} sx={{ top: "0" }} />
        )}
      >
        <App />
      </SnackbarProvider>
    </Provider>
  );
};
